<script lang="ts">
	import { BaseInput, Button, ButtonType, ButtonSize, Modal } from '@repo/commons/components'

	interface LinkDialogProps {
		isOpen: boolean
		selectedText: string
		onConfirm: (text: string, url: string) => void
		onCancel: () => void
	}

	let { isOpen, selectedText, onConfirm, onCancel }: LinkDialogProps = $props()

	let linkText = $state('')
	let linkUrl = $state('')
	let textInputRef = $state<HTMLInputElement>()
	let urlInputRef = $state<HTMLInputElement>()

	$effect(() => {
		if (isOpen) {
			linkText = selectedText || ''
			linkUrl = ''
			setTimeout(() => {
				if (selectedText) {
					urlInputRef?.focus()
				} else {
					textInputRef?.focus()
				}
			}, 0)
		}
	})

	function handleSubmit(event: Event) {
		event.preventDefault()
		if (linkText.trim() && linkUrl.trim()) {
			onConfirm(linkText.trim(), linkUrl.trim())
		}
	}

	// Auto-add https:// if no protocol is specified
	function handleUrlBlur() {
		if (linkUrl && !linkUrl.match(/^https?:\/\//)) {
			linkUrl = 'https://' + linkUrl
		}
	}
</script>

<Modal
	title="Add Link"
	showCloseButton={false}
	visible={isOpen}
	onclose={onCancel}
	contentStyle="padding-top: 0.5rem"
>
	<form onsubmit={handleSubmit} class="dialog-form">
		<BaseInput
			label="Selected Text"
			type="text"
			size="md"
			value={linkText}
			onInput={(value) => {
				linkText = value
			}}
			placeholder="Enter link text..."
			bind:this={textInputRef}
		/>

		<BaseInput
			label="Link URL"
			type="url"
			size="md"
			value={linkUrl}
			onInput={(value) => {
				linkUrl = value
			}}
			placeholder="https://example.com"
			onBlur={handleUrlBlur}
			bind:this={urlInputRef}
		/>

		<div class="dialog-actions">
			<Button
				buttonText="Cancel"
				buttonType={ButtonType.TERTIARY}
				buttonSize={ButtonSize.MEDIUM}
				onclick={onCancel}
			/>
			<Button
				type="submit"
				buttonText="Add Link"
				buttonType={ButtonType.BRAND}
				buttonSize={ButtonSize.MEDIUM}
			/>
		</div>
	</form>
</Modal>

<style>
	.dialog-form {
		@apply flex flex-col gap-4 w-[434px];
	}

	.dialog-actions {
		@apply flex gap-6 mt-4 justify-end;
	}
</style>
